<template>
    <modal ref="modal" :centered="true" :has-footer="false" @hidden="close" @keyup.native="reply.errors.clear()"><span
            slot="title">Reply to {{ review.reviewer_name }}</span>
        <p>{{ review.body }}</p>
        <div class="form-group"><textarea class="form-control" autofocus="autofocus" ref="replyBox" v-model="reply.body"
                                          placeholder="Write your reply..."
                                          :class="{ 'is-invalid': reply.errors.any() }"></textarea>
            <p class="invalid-feedback" v-if="reply.errors.has('body')">{{ reply.errors.get('body') }}</p>
        </div>
        <button-loading class="btn btn-primary btn-block" @click="sendReply" :loading="reply.submitting"><i
                class="fas fa-reply mr-2" v-if="!reply.submitting"></i>Reply
        </button-loading>
    </modal>
</template>

<script>
    export default {
        props: {
            review: {required: true},
        },

        data() {
            return {
                reply: this.createForm(this.review),
            };
        },

        methods: {
            open() {
                this.$refs.modal.open();
                setTimeout(() => this.$refs.replyBox.focus(), 500);
            },

            close() {
                this.reply = this.createForm(this.review);
                this.$refs.modal.close();
            },

            createForm(data = {}) {
                return new Form({
                    body: null,
                    commentable_type: 'reviews',
                    commentable_id: data.id,
                    user_id: Spark.userId,
                });
            },

            async sendReply() {
                try {
                    const {data} = await this.reply.post(this.$laroute.route('api.comments.store'));
                    this.$emit('replied', data);
                    this.$alert({
                        type: 'success',
                        message: 'Reply sent. We will send an email or text message to the contact.'
                    });
                    this.close();
                } catch (error) {
                    this.$alert({
                        type: 'error',
                        message: 'Sorry! It was not possible to send your reply. Try again later',
                        title: 'Oops!'
                    });
                    console.error('ERROR', error);
                }
            },
        },
    };
</script>
